if (!customElements.get("card-variant-picker")) {
  class CardVariantPicker extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("change", this.onChange.bind(this));
    }

    connectedCallback() {
      this.select = this.querySelector(".card__variant-select");

      if (this.select) {
        this.updateSelectedVariant({ skipImage: true });
      }
    }

    onChange(event) {
      if (event.target.matches(".card__variant-select")) {
        this.updateSelectedVariant();
      }
    }

    updateSelectedVariant({ skipImage = false } = {}) {
      const selectedOption = this.select.options[this.select.selectedIndex];
      const variantId = selectedOption.value;
      const price = selectedOption.dataset.price;
      const compareAtPrice = selectedOption.dataset.compareAtPrice;
      const priceRaw = parseFloat(selectedOption.dataset.priceRaw);
      const compareAtPriceRaw = parseFloat(
        selectedOption.dataset.compareAtPriceRaw,
      );
      const available = selectedOption.dataset.available === "true";
      const featuredImage = selectedOption.dataset.featuredImage;

      this.updateAddToCartButton(variantId, available);
      this.updatePrice(price, compareAtPrice, priceRaw, compareAtPriceRaw);

      if (featuredImage && !skipImage) {
        this.updateImage(featuredImage);
      }
    }

    updateAddToCartButton(variantId, available) {
      const card =
        this.closest(".collection-card") || this.closest(".card__container");
      if (!card) return;

      const productForm = card.querySelector('input[name="id"]');
      const submitButton = card.querySelector('button[name="add"]');
      const submitButtonText = submitButton?.querySelector("span");

      if (productForm) {
        productForm.value = variantId;
      }

      if (submitButton) {
        if (!available) {
          submitButton.disabled = true;
          if (submitButtonText) {
            submitButtonText.textContent =
              (window.variantStrings && window.variantStrings.soldOut) ||
              "Sold Out";
          }
        } else {
          submitButton.disabled = false;
          if (submitButtonText) {
            submitButtonText.textContent =
              (window.variantStrings && window.variantStrings.addToCart) ||
              "Add to cart";
          }
        }
      }
    }

    updatePrice(price, compareAtPrice, priceRaw, compareAtPriceRaw) {
      const card =
        this.closest(".collection-card") || this.closest(".card__container");
      if (!card) return;

      const priceContainer =
        card.querySelector(".card__price .price") ||
        card.querySelector(".card__price");
      if (!priceContainer) return;

      const regularPriceDiv = priceContainer.querySelector(".price__regular");
      const salePriceDiv = priceContainer.querySelector(".price__sale");
      const regularPriceItem = regularPriceDiv
        ? regularPriceDiv.querySelector(".price-item--regular")
        : null;
      const salePriceItem = salePriceDiv
        ? salePriceDiv.querySelector(".price-item--sale")
        : null;
      const comparePriceItem = salePriceDiv
        ? salePriceDiv.querySelector(".price-item--regular")
        : null;
      const percentItem = priceContainer.querySelector(".price-item--percent");
      const priceDiv = priceContainer.closest(".price") || priceContainer;

      const isOnSale = compareAtPriceRaw > priceRaw;

      // Toggle Visibility Explicitly
      if (regularPriceDiv && salePriceDiv) {
        if (isOnSale) {
          regularPriceDiv.classList.add("hidden");
          regularPriceDiv.style.display = "none";

          salePriceDiv.classList.remove("hidden");
          salePriceDiv.style.display = "block";

          if (priceDiv) {
            priceDiv.classList.add("price--on-sale");
            priceDiv.classList.remove("price--no-compare");
          }
        } else {
          regularPriceDiv.classList.remove("hidden");
          regularPriceDiv.style.display = "block";

          salePriceDiv.classList.add("hidden");
          salePriceDiv.style.display = "none";

          if (priceDiv) {
            priceDiv.classList.remove("price--on-sale");
            priceDiv.classList.add("price--no-compare");
          }
        }
      }

      // Update Text Content
      if (price) {
        if (regularPriceItem) regularPriceItem.innerHTML = price;
        if (salePriceItem) salePriceItem.innerHTML = price;
      }

      if (comparePriceItem && compareAtPrice) {
        comparePriceItem.innerHTML = compareAtPrice;
      }

      // Update Percentage
      if (percentItem) {
        if (isOnSale && compareAtPriceRaw > 0) {
          const percent = Math.round(
            ((compareAtPriceRaw - priceRaw) / compareAtPriceRaw) * 100,
          );
          percentItem.innerText = "-" + percent + "%";
          percentItem.style.display = "";
        } else {
          percentItem.style.display = "none";
        }
      }
    }

    updateImage(src) {
      const card =
        this.closest(".collection-card") || this.closest(".card__container");
      if (!card) return;

      const img = card.querySelector(".card__picture .card__img");
      if (img) {
        img.src = src;
        img.removeAttribute("srcset");
      }
    }
  }

  customElements.define("card-variant-picker", CardVariantPicker);
}
